var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodIconTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assets/icons/travel/32-KnifeandFork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40353 8.5C9.40353 5.64075 10.3105 0 11.8361 0C12.3664 0 12.6117 0.50675 12.6117 1.044V15C12.6117 15.5522 12.1697 16 11.6246 16C11.0794 16 10.6374 15.5522 10.6374 15V9.58075C9.95238 9.58075 9.40353 9.19575 9.40353 8.5ZM6.20648 4.2127H6.97511V0.2H7.99995V5.46667C7.99995 6.15911 7.4263 6.72063 6.7189 6.72063V14.9968C6.7189 15.5508 6.26003 16 5.69407 16C5.1281 16 4.66923 15.5508 4.66923 14.9968V6.72063C3.96184 6.72063 3.38818 6.15911 3.38818 5.46667V0.2H4.41302V4.2127H5.18165V0.2H6.20648V4.2127Z",
    fill: "#2800A0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIconTransavia);
export default __webpack_public_path__ + "static/media/food-icon-transavia.89d50037f35e8034fb251560c0a97ad0.svg";
export { ForwardRef as ReactComponent };